import React from 'react'
import { Button, ButtonProps } from './Button'

export const ButtonLinkSecondary: React.SFC<ButtonProps> = props => (
  <Button type="link-secondary" {...props} />
)
